export enum ScheduledPaymentPaymentTermsEnum {
  PREPAYMENT = 'PREPAYMENT',
  SUBSEQUENT = 'SUBSEQUENT'
}
